export const PageSupport = () => (
    <div style={{height: 112}}>
        {" "}
    </div>
)